// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"OnboardingApprovalViewer_loaderWrapper__cU26G","approvalLoader":"OnboardingApprovalViewer_approvalLoader__4pKGI"};